import EmailInput from '../../../common/components/Auth/EmailInput'
import { useForm, SubmitHandler } from 'react-hook-form'
import { EmailPassFormInputs } from '../../../types/EmailPassFormInputs'
import { useNavigate } from 'react-router-dom'
import globalStyles from '../../../styles/confirmation.module.css'
import Button from '../../../common/components/Button'
import AuthBase from '../../../common/components/Auth/AuthBase'
import { resetPassword } from '../../../common/utils/cognito'
import { t } from 'i18next'

const ResetPasswordPage = () => {
  const navigate = useNavigate()
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<EmailPassFormInputs>()

  const onSubmit: SubmitHandler<EmailPassFormInputs> = ({ email }) => {
    resetPassword(email)
    navigate(`/set-new-password?username=${encodeURIComponent(email)}`)
  }

  return (
    <AuthBase hasBackButton>
      <p className={globalStyles.formLabel}>Forgot Password?</p>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={globalStyles.formContainer}
      >
        <EmailInput register={register} errors={errors} />
        <div>
          <Button title={t('profile.resetPassword')} />
        </div>
      </form>
    </AuthBase>
  )
}

export default ResetPasswordPage
